import { useState } from 'react';
import { styled, alpha } from '@mui/material/styles';
import { SlideshowOutlined, Search as SearchIcon } from '@mui/icons-material';
import { TabDrawer, TabDrawerProps } from '@centerpiece/components';
import { Box, InputBase, useMediaQuery, useTheme } from '@mui/material';

import { LoomPage } from 'pages/LoomPage';

export interface TutorialTabDrawerProps
  extends Omit<TabDrawerProps, 'tabs' | 'setTabs' | 'title' | 'status'> {}

export const TutorialTabDrawer = (props: TutorialTabDrawerProps) => {
  const theme = useTheme();
  const [search, setSearch] = useState<string>('');
  return (
    <TabDrawer
      width={{ xs: '100%' }}
      maxWidth={theme.breakpoints.values.lg}
      {...props}
      title={'Tutorial Videos'}
      initialTab="tutorial"
      tabIcons={[
        <Search onChange={event => setSearch((event?.target as any)?.value)}>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase placeholder="Search Videos" />
        </Search>,
      ]}
      tabs={{
        tutorial: {
          key: 'tutorial',
          visible: true,
          sequence: 1,
          icon: <SlideshowOutlined />,
          backgroundColor: 'white',
          contents: (
            <TabContentWrapper>
              <LoomPage search={search} />
            </TabContentWrapper>
          ),
        },
      }}
    />
  );
};

const TabContentWrapper = ({ children = null } = {} as any) => {
  const theme = useTheme();
  const downSm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ ...(downSm ? { marginLeft: -1, marginRight: -1 } : {}) }}>
      {children}
    </Box>
  );
};

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  border: '1px solid black',
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));
